import React from "react";
import { useAppContext } from "../../helpers/account-context";
import { ResultLine, DetailLine, InfowinLine } from "./Mixin";

const ViewDetails = (props) => {
  const { item } = props;
  const directionUrl = `${window.shopUrl || ''}/a/store-locator/details/${item.properties.slug}`;
  const { getLocale } = useAppContext()
  return (
    <a className="cbmap-link" href={`${directionUrl}`}>
      {getLocale('view_details')}
    </a>       
  );
};

export const ViewDetailsResult = (props) => {
  return (
    <ResultLine className="cbmap-item_view_details">
      <ViewDetails {...props} />
    </ResultLine>
  );
};

export const ViewDetailsDetail = (props) => {
  return (
    <DetailLine className="cbmap-details_view_details">
      <ViewDetails {...props} />
    </DetailLine>
  );
};

export const ViewDetailsInfowin = (props) => {
  return (
    <InfowinLine className="cbmap-infowin_view_details">
      <ViewDetails {...props} />
    </InfowinLine>
  );
};
